/* eslint-disable no-shadow */
export enum AccountTypeEnum {
  SimpleIRA = "SIMPLE IRA",
  SEPIRA = "SEP IRA",
  SARSEPIRA = "SARSEP IRA",
  TraditionalIRA = "Traditional IRA",
  RolloverIRA = "Rollover IRA",
  QualifiedRetirementPlan = "Qualified Retirement Plan [401(k), Profit Sharing]",
  Plan403b = "403(b) Plan",
  Governmental457bPlan = "Governmental 457(b) Plan",
  RothIRA = "Roth IRA"
}
/* eslint-enable no-shadow */
